import * as Sentry from '@sentry/vue';
import router from '@/router';

/**
 * 일반 센트리 채널로 알림을 전송함
 */

export const gapSentryChannel =
  {
    /**
     * DSN을 GAP SENTRY로 바꿔서 전송 후 다시 기존 sentry로 되돌린다.
     * @param e exception
     */
    captureException(e){
      // DSN 바꿔서 전송하고
      Sentry.init({
        dsn: process.env.VUE_APP_GAP_SENTRY_DSN,
        environment: process.env.NODE_ENV,
        integrations: [
          browserTracingInstance,
          replayInstance,
        ],
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0
      });
      Sentry.captureException(e);

      // DSN 원래대로 되돌리기
      Sentry.init(sentryConfig);
    }
  };
  
  const replayInstance = new Sentry.Replay();
  const browserTracingInstance = new Sentry.BrowserTracing({
    tracePropagationTargets: ["localhost", process.env.VUE_APP_DOMAIN, process.env.VUE_APP_INTERNAL_DOMAIN],
    routingInstrumentation: () => Sentry.vueRouterInstrumentation(router),
  });
  
  export const sentryConfig = {
    dsn: 'https://5bbeae09d2bc403690599ddfc379a20e@o807406.ingest.sentry.io/4505152586055680',
    environment: process.env.NODE_ENV,
    integrations: [
      browserTracingInstance,
      replayInstance,
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  };
